import {ITreeNode} from "@blueprintjs/core"
import DisplayData from "../models/displayData"
import {ExportOptions, RefDbDataContext} from "../models/displayDataContext"
import DisplayDataTableData from "../models/displayDataTableData"
import DisplayDataContextValues from "../models/displayDataContextValues"
import Matrix from "../models/matrix"
import GenerateTableType from "../../shared/enums/generateTableType"
import {Switches} from "../models/componentSwitch"
import SwitchableValue from "../models/switchableValue"

export interface State {
    displayData: DisplayData
    context: RefDbDataContext
    multiContext: RefDbDataContext[]
    isLoadingDisplayData: boolean
    isExporting: boolean
    generateTable: GenerateTableType
    sampleSelection: {
        availableTreeNodes: ITreeNode[]
        isLoading: boolean
    }
}

const initialExportOptions: ExportOptions = {
    transposeValues: false,
    addComments: false,
    exportStatus: false,
    exportAllValueTypes: false,
}

export const initialState = {
    displayData: {
        data: new DisplayDataTableData(),
        contextValues: {
            metabolites: [],
            assay: [],
            species: [],
            projects: [],
            classes: [],
            filters: undefined,
            matrices: [],
            values: {},
        } as DisplayDataContextValues,
    },
    context: {
        species: undefined,
        assay: SwitchableValue.disable([]),
        material: undefined,
        projects: SwitchableValue.disable([]),
        metabolites: SwitchableValue.disable([]),
        classes: SwitchableValue.disable([]),
        filters: undefined,
        matrixType: new Matrix(),
        ownSamples: false,
        showHmdbId: false,
        exportFileType: undefined,
        includesSummary: true,
        log2Transformation: false,
        categorizeDetectability: false,
        sumUpMetaboliteClasses: false,
        totalSampleNumber: undefined,
        switches: undefined,
    } as RefDbDataContext,
    multiContext: [RefDbDataContext.of(0, [], Object.values(Switches))],
    isLoadingDisplayData: false,
    isExporting: false,
    sampleSelection: {
        availableTreeNodes: [],
        isLoading: false,
    },
    generateTable: undefined,
}
